export var TimeoutOptions = ["bloodRule", "mandatory"];
